module.exports = __webpack_public_path__ + "static/media/icn_old_age_covid_myway.c475be50.svg";